<template>
	<div class="row">
		<div class="col-md-offset-1 col-md-10">

			<div class="panel panel-primary" data-collapsed="0">

				<div class="panel-heading">
					<div class="panel-title">
						<i class="fa fa-angle-right"></i> Banner 
					</div>

				</div>

				<div class="panel-body">
					<form role="form" class="form-horizontal" @submit.prevent="submit($event.target)">


                        <div class="form-group">
							<label class="col-sm-3 control-label">Imagen:</label>
							<div class="col-sm-7">
								<div class="fileinput fileinput-new" data-provides="fileinput">
									<div class="fileinput-new thumbnail" style="width: 200px; height: 150px;"
										data-trigger="fileinput">
										<img :src="content.imageUrl" alt="..." v-if="id!=''">
										<img src="//placehold.it/200x150?text=Imagen" alt="..." v-else>
									</div>
									<div class="fileinput-preview fileinput-exists thumbnail"
										style="max-width: 200px; max-height: 150px"></div>
									<div>
										<span class="btn btn-white btn-file">
											<span class="fileinput-new">Seleccionar imagen</span>
											<span class="fileinput-exists">Cambiar</span>
											<input type="file" accept="image/*" name="image">
										</span>
										<a href="#" class="btn btn-orange fileinput-exists" data-dismiss="fileinput">Remover</a>
									</div>
								</div>
							</div>
						</div>

						<div class="form-group">
							<checkbox-form name="active" text="Activo" :data.sync="content.status"></checkbox-form>
						</div>


						<div class="form-group">
							<div class="col-sm-12">

								<button type="submit" class="btn btn-success pull-right"><i class="far fa-save"></i> Guardar</button>

							</div>
						</div>
					</form>
				</div>
			</div>
		</div>

	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return {

				customToolbar: [
					[{ 'font': [] }],
					[{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
					['bold', 'italic', 'underline'],
					[{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
					[{ 'list': 'ordered'}, { 'list': 'bullet' }]//,
					//['image', 'code-block']
				],

				content:{
					id:null,
					body:'',
					status:false

				},
				id:8,

			}
		},

		methods:{
			getContent(){
				this.$parent.inPetition=true;
				axios.get(tools.url("/api/admin/bannerhome")).then((response)=>{
			    	this.content = response.data;
			    	this.content.status = (this.content.status)?(true):(false);
			    	
			    	this.$parent.inPetition=false;
			    }).catch((error)=>{
			    	this.$parent.handleErrors(error);
			        this.$parent.inPetition=false;
			    });
			},
			submit(form){

				this.$parent.inPetition=true;
				this.$parent.validateAll(()=>{

					var data=tools.params(form, this.content);

					axios.post(tools.url("/api/admin/bannerhome"),data).then((response)=>{
				    	this.$parent.showMessage("Registro se actualizado correctamente!","success");
				    	this.$parent.inPetition=false;
				    }).catch((error)=>{
				    	this.$parent.handleErrors(error);
				        this.$parent.inPetition=false;
				    });

				},(e)=>{
					console.log(e);
					this.$parent.inPetition=false;
				});
			},


		},

		mounted(){
			this.getContent();
		}
	}
</script>
